import React from 'react';
import { Link } from 'react-router-dom';
import URI from 'urijs';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';

// images
import notfound from '../POISearch/images/notfound.png';

// modules
import styles from '../Containers.module.scss';

const PHOTO_BASE_URL = '//communityphotos.naplesarea.com/';

function CommunityResult({ record }) {
  const id = record.name.replace(/(\s)/g, '-');
  return (
    <tr className={styles.result}>
      <td className={cx(BS.textCenter, BS.dNone, BS.dMdTableCell)}>
        <img
          src={record.photo ? `${PHOTO_BASE_URL}${record.photo}` : notfound}
          alt={`${record.name}`}
          onError={e => {
            e.target.src = notfound;
            e.target.className = cx(e.target.className, BS.b1);
          }}
          className={cx({
            [BS.b1]: !record.photo
          })}
        />
      </td>
      <td>
        <div className={cx(BS.textCenter, BS.dMdNone, BS.pb1)}>
          <h6>
            <Link to={URI(`/community/${id}`).toString()}>{record.name}</Link>
          </h6>
          <img
            src={record.photo ? `${PHOTO_BASE_URL}${record.photo}` : notfound}
            alt={`${record.name}`}
            onError={e => {
              e.target.src = notfound;
              e.target.className = cx(e.target.className, BS.b1);
            }}
            className={cx({
              [BS.b1]: !record.photo
            })}
          />
        </div>
        <h6 className={cx(BS.dNone, BS.dMdBlock)}>
          <Link to={URI(`/community/${id}`).toString()}>{record.name}</Link>
        </h6>
        <p
          dangerouslySetInnerHTML={{
            __html: record.description
          }}
        />
        <p>
          <Link to={URI(`/community/${id}`).toString()}>
            View Details and Active Listings
          </Link>
        </p>
      </td>
    </tr>
  );
}

export default CommunityResult;



// WEBPACK FOOTER //
// ./src/containers/CommunitySearch/CommunitySearchResult.js